/**
 * Fetch-клиент к apps/bot HTTP API.
 * Каждый запрос идёт с Telegram initData в заголовке — backend верифицирует HMAC с bot_token.
 */
import { getInitData } from './tg';
import type { ApiResult } from '@amrita/shared';

const API_BASE = import.meta.env.VITE_API_BASE ?? '';

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      'X-Telegram-Init-Data': getInitData(),
      ...(init.headers ?? {}),
    },
  });
  const json = (await res.json()) as ApiResult<T>;
  if (!res.ok || !json.ok) {
    const msg = !res.ok ? `HTTP ${res.status}` : (json as { ok: false; error: { error: string } }).error.error;
    throw new Error(msg);
  }
  return json.data;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body: unknown) =>
    request<T>(path, { method: 'POST', body: JSON.stringify(body) }),
  put: <T>(path: string, body: unknown) =>
    request<T>(path, { method: 'PUT', body: JSON.stringify(body) }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};
